import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./store/redux/slices/authSlice";
import Maintenance from "./screens/maintenance/Maintenance";

function App() {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const tokenInvalid = token == null || token === undefined;
    const userInvalid = user == null || user === undefined;
    const dealerCodeInvalid =
      user?.dealerCode == null || user?.dealerCode === undefined;
    const dealerNameInvalid =
      user?.dealerName == null || user?.dealerName === undefined;
    const hasAuthData = token != null || user != null;

    if (
      hasAuthData &&
      (tokenInvalid || userInvalid || dealerCodeInvalid || dealerNameInvalid)
    ) {
      dispatch(logout());
    }
  }, [dispatch, token, user]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Maintenance />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="*" element={<Maintenance />} />

        {/*
          Maintenance mode is enabled by default.
          The original public and protected routes are intentionally
          commented out below so they can be restored later if needed.

          <Route path="/login" element={<Login />} />

          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/add-customer" element={<CustomerForm />} />
            <Route path="/receive-payments" element={<Receivepayments />} />
            <Route path="/book-order" element={<BookOrder />} />
            <Route path="/customer-summary" element={<CustomerSummary />} />
            <Route path="/pbo-form" element={<PBOForm />} />
            <Route path="/view-pbo" element={<ViewPBOform />} />
            <Route path="/refund-request" element={<BookingCancellation />} />
            <Route path="/receive-vehicle" element={<ReceiveVehicle />} />
            <Route path="/vehicle-issuance" element={<VehicleIssuance />} />
            <Route path="/dealer-stock-report" element={<DealerStockReport />} />
            <Route
              path="/vehicle-movement-report"
              element={<VehicleMovementReport />}
            />
            <Route path="/order-status-report" element={<OrderStatusReport />} />
            <Route path="/change-password" element={<ChangePassword />} />
          </Route>
        */}
      </Routes>
    </Router>
  );
}

export default App;
